import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function knowledgeBase() {
    document.addEventListener( 'DOMContentLoaded', function () {
        const blocks = document.querySelectorAll('.knowledgeBase');
        if(blocks){
        blocks.forEach(block=>{
            new Splide(block, {
              perPage: 3,
              perMove: 1,
              autoplay: false,
              pagination: false,
              arrows: true,
              gap: '20px',
              fixedWidth : '330px',
              fixedHeight : '620px',
              slideFocus: true,
              breakpoints: {
                991: {
                  perPage : 2,
                  perMove : 1,
                  fixedWidth : false,
                  fixedHeight : false,
                  arrows: false,
                  pagination: true
                },
                768: {
                  perPage : 1,
                  arrows: false,
                  perMove : 1,
                  pagination : false,
                  padding: { left: 'rem', right: '4rem' },
                  fixedHeight : '400px',
                  fixedWidth : '100%',
                  gap: '10px'
                },
              
              }
              }).mount();
        });
      }
    })
}